export default __webpack_public_path__ + "static/rendition-200w-example-7bebb63770c650ecbea218d22615d278.gif";